import { Outlet } from "react-router-dom";
import { SharedLayoutVideo } from "../components/shared-layout-video";

export function ZoneLayout() {
  return (
    <div>
      <Outlet />

      <SharedLayoutVideo />
    </div>
  );
}
